import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    EventEmitter,
    Input,
    OnChanges,
    OnInit,
    Output,
    SimpleChanges
} from '@angular/core';
import {UtilService} from '../../services/util.service';

@Component({
    selector: 'app-vin-light',
    templateUrl: './vin-light.component.html',
    styleUrls: ['./vin-light.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class VinLightComponent implements OnInit, OnChanges {
    @Input() vin: string;
    @Output() vinChange = new EventEmitter();
    @Output() vinEdited = new EventEmitter();

    private replacements = {
        i: '1',
        I: '1',
        o: '0',
        O: '0',
        q: '0',
        Q: '0'
    };

    constructor(private cd: ChangeDetectorRef) {
    }

    ngOnInit() {
        if (this.vin) {
            this.checkVin();
        }
    }

    onVinChange() {
        this.checkVin();
        this.onChange();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.vin !== undefined) {
            this.checkVin();
           // this.onChange();
        }
    }

    private checkVin() {
        if (this.vin !== null && this.vin !== '') {
            this.cd.detectChanges();
            this.vin = UtilService.replaceAll(this.vin, this.replacements);
            this.vin = this.vin.toUpperCase();
            this.cd.markForCheck();
        }
    }

    private onChange() {
        this.vinChange.emit(this.vin);
    }

    emitVinEdited() {
        this.vinEdited.emit();
    }
}
